import "./EmployeeStatusUI.css";

import {
	EmployeeStatusheaderColumns,
	employeeStatusInitialData,
} from "../../EmployeeStatusSetup";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity } from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { EmployeeStatusToolbar } from "./EmployeeStatusToolbar/EmployeeStatusToolbar";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useTheme } from "@mui/material";

// import { Button } from "primereact/button";

// import { Toolbar } from "primereact/toolbar";








let emptyEmpStatus = {
	id: null,
	employeeStatus: null,
	date: null,
	notes: null,
	rowWithRandomId: true,
};

interface IEmployeeStatusDataTable {
	employeeStatusUpdatedData: (data: any) => void;
	employeeStatusDataItems: any;
	employeeStatusDDLData: any;
	selectedEmployeeLabel: string;
	onRowDeleteClicked: (data: any) => void;
	salaryProfilePermissionsData: any
}
export const EmployeeStatusDataTable: FC<IEmployeeStatusDataTable> = ({
	employeeStatusUpdatedData,
	employeeStatusDataItems,
	employeeStatusDDLData,
	selectedEmployeeLabel,
	onRowDeleteClicked,
	salaryProfilePermissionsData
}) => {
	const theme = useTheme();
	const [employeeStatus, setEmployeeStatus] = useState<any>(
		employeeStatusDataItems
	);
	// const [selectedEmployeeStatus, setSelectedEmployeeStatus] =
	// 	useState<any>(null);
	const [empStatus, setEmpStatus] = useState(emptyEmpStatus);

	const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);
	const [employeeStatusFieldsEmpty, setEmployeeStatusFieldsEmpty] = useState(emptyEmpStatus);

	useEffect(() => {
		employeeStatusUpdatedData(employeeStatus);
	}, [employeeStatus]);

	useEffect(() => {

		setEmployeeStatus(employeeStatusDataItems);
	}, [employeeStatusDataItems]);

	// useEffect(() => {
	//   const lastIndex = employeeStatus.length - 1;
	//   if (lastIndex >= 0) {
	//     setLastAddedRowId(employeeStatus[lastIndex].id);
	//   }
	// }, [employeeStatus]);


	const findIndexById = (id: string | number | any) => {
		let index = -1;

		for (let i = 0; i < employeeStatus.length; i++) {
			if (employeeStatus[i].id === id) {
				index = i;
				break;
			}
		}

		return index;
	};

	const createId = () => {
		let id = "";
		let chars =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (let i = 0; i < 5; i++) {
			id += chars.charAt(Math.floor(Math.random() * chars.length));
		}

		return id;
	};

	// const openNew = () => {
	// 	// alert("new")

	// 	let _employeeStatus = [...employeeStatus];
	// 	let _empStatus: any = { ...empStatus };

	// 	if (empStatus.id) {
	// 		const index = findIndexById(empStatus.id);

	// 		_employeeStatus[index] = _empStatus;
	// 	} else {
	// 		// _empStatus.id = createId();
	// 		// _employeeStatus.push(_empStatus);
	// 		  const newRowId = createId();
	//   _block17BSetupPanelNewRow.id = newRowId;
	//   _block17BSetupPanelData.push(_block17BSetupPanelNewRow);
	//   setLastAddedRowId(newRowId && newRowId);
	// 	}
	// 	setEmployeeStatus(_employeeStatus);
	// 	setEmpStatus(emptyEmpStatus);
	// };

	const openNew = () => {
		// if (employeeStatus && employeeStatus.length >= 5) return null;
		let _employeeStatusSetupPanelData = [...employeeStatus];
		let _employeeStatusSetupPanelNewRow: any = { ...employeeStatusFieldsEmpty };

		if (employeeStatusFieldsEmpty.id) {
			const rowIndex = findIndexById(employeeStatusFieldsEmpty.id);
			_employeeStatusSetupPanelData[rowIndex] = _employeeStatusSetupPanelNewRow;

		} else {
			const newRowId = createId();
			_employeeStatusSetupPanelNewRow.id = newRowId;
			_employeeStatusSetupPanelData.push(_employeeStatusSetupPanelNewRow);
			setLastAddedRowId(newRowId && newRowId);

		}
		setEmployeeStatus(_employeeStatusSetupPanelData);
		setEmployeeStatusFieldsEmpty(emptyEmpStatus);
	};

	const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		setEmployeeStatus((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});
	};

	const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		if (field.field === "date") {
			if (
				rowData.employeeStatus !== "" &&
				rowData.employeeStatus !== undefined &&
				rowData.employeeStatus !== null
			) {
				if (rowData.date === null) {
					return "p-component p-filled calender-error-input";
				} else if (rowData.date === "") {
					return "p-component p-filled calender-error-input";
				}
			}
		} else if (field.field === "employeeStatus") {
			if (
				rowData.date !== "" &&
				rowData.date !== undefined &&
				rowData.date !== null
			) {
				if (rowData.employeeStatus === null) {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				} else if (rowData.employeeStatus === "") {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				}
			} else {
				return "p-component p-filled input-dropdown-fields .p-dropdown";
			}
		} else {
			return "p-component p-filled input-dropdown-fields";
		}
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		if (x.field === "label") {
			return (
				<span>
					<b>
						Select Employee Status
					</b>
				</span>
				// <span style={{ color: "red" }}>*</span>
			);
		} else if (x.field === "employeeStatus") {
			return (
				<Dropdown
					options={employeeStatusDDLData}
					value={rowData.employeeStatus}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					placeholder="--"
					className={renderErrorClass(x, row.rowIndex, rowData)}
					optionLabel="label"
					optionValue="value"
				/>
			);
		} else if (x.field === "date") {
			return (
				<Calendar
					value={rowData[x.field]}
					// className="calender"
					style={{
						margin: "8px 0px 4px 0px",
						width: "auto",
					}}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					placeholder={"dd/mm/yyyy"}
					showButtonBar
					showIcon
					className={`calender ${renderErrorClass(x, row.rowIndex, rowData)}`}
					disabled={
						salaryProfilePermissionsData && salaryProfilePermissionsData.lastPeriodProcessed !== null &&
						new Date(salaryProfilePermissionsData.lastPeriodProcessed) > new Date(rowData[x.field]) &&
						salaryProfilePermissionsData.calculatePayroll &&
						!rowData.rowWithRandomId
					}
				/>
			);
		} else if (x.field === "notes") {
			return (
				<InputText
					value={rowData[x.field]}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					placeholder="Write notes here"
					className={"notesField p-component p-filled input-dropdown-fields"}
				/>
			);
		}
	};


	const onDeleteNewAddedRow = (rowId: any) => {
		setEmployeeStatus((prev: any[]) => {
			const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

			if (rowDeleteBasedOnId.length > 1) {
				const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
				setLastAddedRowId(lastRowId);
			} else {
				setLastAddedRowId(null);
			}
			return rowDeleteBasedOnId;
		});
	}

	console.log('employeeStatus1234', employeeStatus)
	console.log('lastAddedRow', lastAddedRowId)
	return (
		<>
			<div className="card">
				<EmployeeStatusToolbar
					openNew={openNew}
					selectedEmployeeLabel={selectedEmployeeLabel}
				// confirmDeleteSelected={confirmDeleteSelected}
				// onMoveUpClickHandler={onMoveUpClickHandler}
				// onMoveDownClickHandler={onMoveDownClickHandler}
				// selectedEmployeeStatus={selectedEmployeeStatus}
				/>
				<DataTable
					value={employeeStatus}
					// selection={selectedEmployeeStatus}
					// onSelectionChange={(e) => setSelectedEmployeeStatus(e.value)}
					dataKey="id"
					key={lastAddedRowId || JSON.stringify(salaryProfilePermissionsData)}
					showGridlines
					className="EmployeeStatus"
					editMode="cell"
					resizableColumns
					columnResizeMode="expand"
					scrollable
					// reorderableColumns
					filterDisplay="menu"
					// selectionMode="checkbox"
					scrollHeight="516px"
				>
					{/* <Column
                      selectionMode="multiple"
                      // hidden={!showChecboxColumn}
                      frozen={true}
                      resizeable={false}
                      style={{ 
                        width: "36px",
                        textAlign: "center",
                        // zIndex:1,
                        borderRight:"1px solid #e5e7eb",
                        top:0
                       }}
                      field="selection"
                      columnKey="selection"
                      className="selectionHeader"
                      // headerStyle={{zIndex:'2!important'}}
                    /> */}
					{EmployeeStatusheaderColumns.map((x: any, index: any) => {
						return (
							<Column
								key={index}
								field={x.field}
								header={x.headerName}
								headerTooltip={x.description}
								headerTooltipOptions={{ position: "top" }}
								// sortable={false}
								// resizeable={x.resizable}
								// dataType={x.type}
								align={x.align}
								alignHeader={x.headerAlign}
								// reorderable={x.disableReorder}
								// exportable={x.disableExport}
								frozen={x.frozenColumn}
								columnKey={x.field}
								style={{
									width: x.minWidth,
									fontSize: "0.875rem",
								}}
								footer={x.footer}
								body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
							/>
						);
					})}
					<Column
						body={(rowData: any, row: any) => {
							const isLastRow = row.rowIndex === employeeStatus.length - 1;
							console.log("isLastRow", isLastRow)
							return isLastRow ? (
								<EnhancedButtonPrimeReact
									icon="pi pi-times"
									severity={EnhancedButtonPrimeReactSeverity.Danger}
									className="p-button-rounded p-button-text shadow-none bg-transparent  delete-row-btn"
									rounded
									onClickHandler={() => rowData.rowWithRandomId ? onDeleteNewAddedRow(rowData.id) : onRowDeleteClicked(rowData)}
								/>
							) : null;
						}}
					/>
				</DataTable>
			</div>
		</>
	);
};
